export const companySettingKeys = {
  nodeAlias: "NODE_ALIAS",
  nodeTableColumns: "NODE_TABLE_COLUMNS",
};
